/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';
import { withStyles, createTheme, ThemeProvider } from '@material-ui/core/styles'

import { CircularProgress, Paper, Typography, Divider, Chip, Button, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText } from '@material-ui/core'

import {ResponsiveContainer, ComposedChart, Bar, BarChart, Tooltip, XAxis, YAxis, CartesianGrid, Legend} from 'recharts'

import Action from '../../../fluid/Actions/ActionFactory';

const blue_theme = createTheme({
    palette: {
        primary: {
          main: '#2296f3',
        },
        secondary: {
            main: '#dc014e',
        }
      },
})

const styles = theme => ({

})

//let colors = ['#5bbae6', '#b6d956', '#fac364', '#8cd3ff', '#d998cb', '#f2d248', '#93b9c5', '#cdc5a8', '#52bbcb', '#dbdb46', '#98aafb']
//let colors = ['#2e59a8', '#4771b2', '#5d8abd', '#73a2c6', '#8abccf', '#a5d5d8', '#c5eddf', '#ffffe0']
//let colors = ['#003f5c','#444e86', '#955196', '#dd5182', '#ff6e54', '#ffa600']
let colors = ['#00429d', '#76a6c8', '#bee8de', '#fd9190', '#d13a5a', '#93003a']
let card_bg = '#00429d'
class DQMDashboard extends Component {
    state = {
        loading_data : false,
        data : null,
        data_error : false,
        selected_source : null,
        selected_fields : [],
        selected_dimensions : []
    } 

    componentDidMount() {
        this.getData()
    }

    getData = () => {
        this.setState({...this.state, loading_data : true, data_error : false, data : null}, () => {
            Action('http_request', {
                url : "/sainapse/configuration/dqm_dash_config",
                method : "get",
                data : {}
            }).then(res => {
                let selected_dimensions = res.data.result.config.dqm_config.dimensions.map(dimension => dimension.name)
                let selected_source = res.data.result.config.dqm_config.data_sources[0].name
                this.setState({...this.state, data : res.data.result.config.dqm_config, selected_source : selected_source, selected_dimensions : selected_dimensions, loading_data: false, data_error : false}, () => console.log('DQM Config : ', this.state.data))
            }).catch(err => {
                this.setState({...this.state, data : null, loading_data: false, data_error : true})
            })
        })
    }

    renderDataSource = () => {
        let data_sources = this.state.data.data_sources.map(src => src.name)
        return (
            <Fragment>
                <FormControl key = 'source-select' style = {{width : '25vw', marginRight : '10px'}} variant='filled' size='small'>
                    <InputLabel>Application Name</InputLabel>
                    <Select
                        value = {this.state.selected_source}
                        onChange = {(event) => this.setState({...this.state, selected_source : event.target.value})}
                    >   
                        {data_sources.map(src => {
                            return (
                                <MenuItem value = {src}>{src}</MenuItem>
                            )
                        })}
                    </Select>   
                </FormControl>
            </Fragment>
        )
    }

    renderDatabase = () => {
        let data_source_index = this.state.data.data_sources.findIndex(src => src.name === this.state.selected_source)
        let database_list = []
        
        if (data_source_index !== -1) {
            database_list = [this.state.data.data_sources[data_source_index].database_name]
        }

        return (
            <FormControl key = 'source-select' style = {{width : '25vw', marginRight : '10px'}} variant='filled' size='small'>
                <InputLabel>Database Name</InputLabel>
                <Select
                    value = {data_source_index !== -1 ? database_list[0] : null}
                    onChange = {(event) => this.setState({...this.state, selected_source : event.target.value})}
                >   
                    {database_list.map(src => {
                        return (
                            <MenuItem value = {src}>{src}</MenuItem>
                        )
                    })}
                </Select>   
            </FormControl>
        )
    }

    renderDimensions = () => {
        return (
            <FormControl key = 'source-select' style = {{flexGrow : 1, marginRight : '10px'}} variant='filled' size='small'>
                <InputLabel>Dimensions</InputLabel>
                <Select
                    multiple
                    value = {this.state.selected_dimensions}
                    onChange = {(event) => this.setState({...this.state, selected_dimensions : event.target.value})}
                >
                    {this.state.data.dimensions.map(dimension => {
                        return (
                            <MenuItem value = {dimension.name}>{dimension.display}</MenuItem>
                        )
                    })}
                </Select>   
            </FormControl>
        )
    }

    renderFields = () => {
        let data_source = this.state.data.data_sources.find(src => src.name === this.state.selected_source)
        return (
            <FormControl key = 'source-select' style = {{flexGrow : 1, marginRight : '10px'}} variant='filled' size='small'>
                <InputLabel>Fields</InputLabel>
                <Select
                    multiple
                    value = {this.state.selected_fields}
                    onChange = {(event) => this.setState({...this.state, selected_fields : event.target.value})}
                >
                    {data_source.fields.map(fld => {
                        return (
                            <MenuItem value = {fld.name}>{fld.name}</MenuItem>
                        )
                    })}
                </Select>   
            </FormControl>
        )
    }

    renderFilters = () => {
        return (
            <Paper square style = {{padding : '10px', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                {this.renderDataSource()}
                {this.renderDatabase()}
                {this.renderDimensions()}
                {this.state.selected_source !== null && this.renderFields()}
            </Paper>
        )
    }

    getDimensionDisplayName = (dimension_name) => {
        let dimensions = this.state.data.dimensions

        let dimension_index = dimensions.findIndex(dmn => dmn.name === dimension_name)
        if (dimension_index !== -1) {
            return dimensions[dimension_index].display
        }
    }

    renderCards = () => {
        let data_source = this.state.data.data_sources.find(src => src.name === this.state.selected_source)
        let dimension_values = []

        data_source.dimension_values.forEach(dimension => {
            if (this.state.selected_dimensions.includes(dimension.name)) {
                dimension_values.push(dimension)
            }
        });

        return (
            <div square style = {{marginTop: '20px', display : 'flex', flexDirection : 'row', justifyContent : 'center'}}>
                {dimension_values.map((dimension, i) => {
                    return (
                        <Paper elevation = {4} square style = {{flexGrow : 1, margin : '5px',height : '100px', backgroundColor : colors[i], padding : '10px'}}>
                            <div style = {{display : 'flex', flexDirection : 'row', borderBottom: '1px solid #FFFFFF'}}>
                                <Typography style = {{flexGrow: 1, color : '#FFFFFF'}} variant = 'h3'>{dimension.value}</Typography>
                                <Typography style = {{color : '#FFFFFF'}} variant = 'h6'>%</Typography>
                            </div>
                            <Typography variant = 'subtitle2' style = {{color : '#FFFFFF'}}>{this.getDimensionDisplayName(dimension.name)}</Typography>
                        </Paper>
                    )
                })}
            </div>
        )
    }

    renderBarChart = () => {
        let chart_data = []
        let data_source = this.state.data.data_sources.find(src => src.name === this.state.selected_source)
        data_source.fields.forEach(field => {
            console.log('DQM Field Selected : ', this.state.selected_fields.length === 0  || this.state.selected_fields.includes(field.name))
            if (this.state.selected_fields.length === 0 || this.state.selected_fields.includes(field.name)) {
                let field_object = {
                    name : field.name
                }
    
                field.dimension_values.forEach(dimension => {
                    if (this.state.selected_dimensions.includes(dimension.name)) {
                        field_object[dimension.name] = parseInt(dimension.value)
                    }
                })
    
                chart_data.push(field_object)
            }
        })

        console.log('DQM Chart Data : ', chart_data)
        return (
            <Paper square style = {{width : '100%', flexGrow : 1, padding : '10px', marginTop : '20px'}}>
                <Typography style = {{marginBottom : '10px'}} variant = 'subtitle2'>Data Quality Score per field and dimension</Typography>
                <ResponsiveContainer width="100%" height="90%">
                <BarChart
                    width={500}
                    height={300}
                    data={chart_data}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                    }}
                    >
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        {this.state.selected_dimensions.map((dimension, i) => {
                            return (
                                <Bar dataKey={dimension} fill={colors[i]} maxBarSize = {40}/>
                            )
                        })}
                    </BarChart>
                </ResponsiveContainer>
            </Paper>
        )

    }

    renderContent = () => {
        if (this.state.data !== null) {
            return (
                <div style = {{width : '100vw', height : 'calc(100vh - 100px)', padding : '10px', display: 'flex', flexDirection : 'column'}}>
                    {this.renderFilters()}
                    {this.renderCards()}
                    {this.renderBarChart()}
                </div>
            )
        } else if (this.state.loading_data) {
            return (
                <div style = {{width : '100vw', height : 'calc(100vh - 100px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <CircularProgress variant='indeterminate' color = 'primary'/>
                </div>
            )
        } else if (this.state.data_error) {
            return (
                <div style = {{width : '100vw', height : 'calc(100vh - 100px)', display : 'flex', flexDirection : 'row', justifyContent : 'center', alignItems : 'center'}}>
                    <Typography variant = 'body2' color = 'secondary'>Error fetching the data</Typography>
                </div>
            )
        }
    }

    render() { 
        return (
            <ThemeProvider theme = {blue_theme}>
                <Paper square style = {{width : '100vw', height : '50px', display : 'flex', flexDirection : 'row', alignItems : 'center'}}>
                    <Typography variant = 'button' style = {{marginLeft : '10px', flexGrow: 1}}>Data Quality Management</Typography>
                    <Button
                        style = {{marginRight : '5px'}}
                        variant = 'contained'
                        size = 'small'
                        color = 'primary'
                        onClick = {this.getData}
                    >Refresh</Button>
                </Paper>
                {this.renderContent()}
            </ThemeProvider>
        );
    }
}
 
export default withStyles(styles)(DQMDashboard);